<template>
  <div>
    <q-input
      v-model="value"
      :mask="mask"
      :label="label"
      :outlined="outlined"
      :dense="dense"
      :rules="rules"
      input-class="cursor-pointer"
      @click.prevent="$refs.qDateProxy.show()"
      :label-color="labelColor"
      :color="iconColor"
    >
      <!-- :rules="rules" -->
      <template v-slot:prepend>
        <q-btn icon="event" class="cursor-pointer" :color="iconColor" dense flat unelevated>
          <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
            <q-date
              v-if="!buttons"
              no-unset
              today-btn
              v-model="date"
              :range="range"
              :default-view="defaultView"
              @input="value = date"
            >
              <div class="row items-center justify-end">
                <q-btn v-if="range" v-close-popup :label="$t('close')" color="negative" no-caps unelevated />
              </div>
            </q-date>

            <q-card v-else flat class="row" unelevated>
              <q-date flat no-unset today-btn v-model="date" :range="range" @input="value = date"> </q-date>
              <q-card-section class="column justify-between items-end">
                <div class="column q-gutter-sm">
                  <q-btn
                    v-for="(presetTimeRange, index) in presetCalendar"
                    :key="index"
                    v-model="value"
                    v-close-popup
                    color="primary"
                    unelevated
                    no-caps
                    style="width: 10em"
                    @click="setValue(presetTimeRange.periodRange)"
                  >
                    {{ presetTimeRange.periodName }}
                  </q-btn>
                </div>
                <q-btn v-if="compare" v-close-popup :label="$t('compare_dates')" color="secondary" dense no-caps unelevated @click="$emit('dateCompare', true);"/>
                <q-btn v-if="range" v-close-popup :label="$t('close')" color="negative" no-caps unelevated />
              </q-card-section>
            </q-card>
          </q-popup-proxy>
        </q-btn>
      </template>
      <template v-slot:append v-if="value && clearable">
        <q-icon name="close" @click.prevent="resetData()" class="cursor-pointer" />
      </template>
    </q-input>
  </div>
</template>

<script>
export default {
  name: 'DateInput',
  props: {
    vModel: [Object, Array, String, Number],
    range: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    dense: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Boolean,
      default: false
    },
    defaultView: {
      type: String,
      default: 'Calendar'
    },
    compare : {
      type: Boolean,
      default: false
    },
    labelColor: {
      type: String,
      default: 'gray-8'
    },
    iconColor: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      date: null
    };
  },

  computed: {
    value: {
      get: function () {
        return this.range ? this.vModel : this.vModel ? this.$moment(this.vModel).format('L') : null;
      },
      set: function (value) {
        if (!value) {
          this.$emit('update', null);
          return;
        }

        if (!this.range) {
          this.$emit('update', value.replace(/\D/g, '-'));
          this.$refs.qDateProxy.hide();
        } else {
          const formattedDate =
            typeof value === 'object' && value
              ? `${this.$moment(value.from).format('L')} - ${this.$moment(value.to).format('L')}`
              : `${this.$moment(value).format('L')} - ${this.$moment(value).format('L')}`;

          console.log(formattedDate);
          this.$emit('update', formattedDate);
        }
      }
    },

    presetCalendar() {
      return [
        {
          periodName: this.$t('today'),
          periodRange: {
            to: this.$moment(),
            from: this.$moment()
          }
        },
        {
          periodName: this.$t('yesterday'),
          periodRange: {
            to: this.$moment().subtract(1, 'days'),
            from: this.$moment().subtract(1, 'days')
          }
        },
        {
          periodName: this.$t('last_7_days'),
          periodRange: {
            from: this.$moment().subtract(7, 'days'),
            to: this.$moment()
          }
        },
        {
          periodName: this.$t('last_30_days'),
          periodRange: {
            to: this.$moment(),
            from: this.$moment().subtract(30, 'days')
          }
        },
        {
          periodName: this.$t('this_month'),
          periodRange: {
            from: this.$moment().startOf('month'),
            to: this.$moment().endOf('month')
          }
        },
        {
          periodName: this.$t('last_month'),
          periodRange: {
            from: this.$moment().subtract(1, 'months').startOf('month'),
            to: this.$moment().subtract(1, 'months').endOf('month')
          }
        }
      ];
    }
  },

  methods: {
    resetData() {
      this.date = null;
      this.value = null;
    },

    setValue(value) {
      this.$emit(
        'update',
        value ? `${this.$moment(value.from).format('L')} - ${this.$moment(value.to).format('L')}` : null
      );
    }
  },

  created() {
    this.range ? (this.mask = '##/##/#### - ##/##/####') : (this.mask = '##/##/####');
  }
};
</script>

<style></style>
